import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15369f46"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-backdrop" }, null, -1))
const _hoisted_2 = { class: "ReportPage" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Tarifas Servicios Aéreos", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  class: "row g-3 needs-validation",
  novalidate: ""
}
const _hoisted_6 = { class: "col-md-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom01",
  class: "form-label"
}, "Fecha Inicio", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_9 = { class: "col-md-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Fecha Final", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Cargo", -1))
const _hoisted_14 = { selected: "" }
const _hoisted_15 = ["value", "onClick"]
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom02",
  class: "form-label"
}, "Costo Hora", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "valid-feedback" }, " Looks good! ", -1))
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "validationCustom04",
  class: "form-label"
}, "Status", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "A" }, "Activo", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "I" }, "Inactivo", -1))
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " Please select a valid state. ", -1))

import { Ref,ref, onMounted } from 'vue'
import axios from 'axios'
import { useDateTimeStore } from '@/store/dateTimeStore';
import { userGlobalStore } from '@/store/userGlobal';
import { UrlGlobal } from '@/store/dominioGlobal';
import { useAlert } from '@/store/useAlert';

export default /*#__PURE__*/_defineComponent({
  __name: 'InCarTarVue',
  props: {
    btnTvIn: Boolean,
    aeronave: String
},
  emits: ['insTvProps'],
  setup(__props, { emit: __emit }) {

const { error, question, success, warning } = useAlert()

const dUrl = UrlGlobal()
const dateTimeStore = useDateTimeStore();
const userStore = userGlobalStore();

//variables reactivas para los campos del formulario
const fecha_inicio = ref<string>('')
const fecha_final = ref<string>('')
const cargo = ref<string>('')
const costo_hora = ref<string>('')
const status = ref<string>('') 

//props y emits----------------------------------------------------------------
const props = __props
const emits = __emit
        const handleClick = () =>{
            emits("insTvProps",!props.btnTvIn)
        }
//----------------------------------------------------------------
// Variables reactivas
status.value = 'A'

// envio del insert a la tabla en la base de datos a traves de la api en django
const handleSubmit = async () =>{
    if (!fecha_inicio.value) {
        error('Digite la fecha de inicio de la vigencia...')
        return
    }
    if (!fecha_final.value) {
        error('Digite la fecha final de la vigencia...')
        return
    }
    if (fecha_inicio.value > fecha_final.value) {
        error('Fecha de Inicio no puede ser mayor a la Fecha Final...')
        return
    }
    if (!cargo.value) {
        error('Tiene que digitar el campo correspondiente...')
        return
    }
    if (typeof costo_hora.value !='number') {
        error ('Información de costo por hora incorrecto...')
        return
    }

    dateTimeStore.refreshDateTime();
    console.log(dateTimeStore.formattedDate)
    const data = {
        model:"cartarvue",
        data:{
            aeronave: props.aeronave,
            fecha_inicio:fecha_inicio.value,
            fecha_final: fecha_final.value,
            cargo: cargo.value,
            creado_por:userStore.globalUser,
            fecha_creado:dateTimeStore.formattedDate,
            hora_creado:dateTimeStore.formattedTime,
            costo_Hora: costo_hora.value,
            status:status.value
        }
    }
    try {
        const response = await fetch(dUrl.urlGlobal +'/api2/insert/',{
            method: 'POST',
            headers:{
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
        if(response.ok){
            const responseData = await response.json()
            console.log("Insercion exitosa:",responseData)
            handleClick()
        }else{
            console.error("Error al insertar en la base de datos:",response.statusText)
        }
    }catch (error){
        console.error("error de red:",error)
    }
}
const cargos = ref<any[]>([]);
onMounted(async () => {
     const responseN = await axios.get(dUrl.urlGlobal + '/api2/caratenvue/filter?status=A')
  cargos.value = responseN.data
})

const descripcionCargos = (cargosId: string) => {
  const encontrado = cargos.value.find(i => i.cargo === cargosId)
  return encontrado ? encontrado.nombre : ''
}
let idncargo : any
const idN = (naturalezaId: string) => {
  idncargo = naturalezaId
}

//----------------------------------------------------------------------------------------------

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("form", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fecha_inicio).value = $event)),
            class: "form-control",
            id: "validationCustom01",
            required: ""
          }, null, 512), [
            [_vModelText, fecha_inicio.value]
          ]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fecha_final).value = $event)),
            class: "form-control",
            id: "validationCustom02",
            required: ""
          }, null, 512), [
            [_vModelText, fecha_final.value]
          ]),
          _hoisted_11
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("select", {
            class: "form-select form-select-sm",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((cargo).value = $event)),
            disabled: false
          }, [
            _createElementVNode("option", _hoisted_14, _toDisplayString(descripcionCargos(_unref(idncargo))), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cargos.value, (i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i.cargo,
                value: i.cargo,
                onClick: ($event: any) => (idN(i.cargo))
              }, _toDisplayString(i.nombre), 9, _hoisted_15))
            }), 128))
          ], 512), [
            [_vModelSelect, cargo.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((costo_hora).value = $event)),
            class: "form-control",
            id: "validationCustom02",
            required: ""
          }, null, 512), [
            [_vModelText, costo_hora.value]
          ]),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("select", {
            class: "form-select",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((status).value = $event)),
            id: "validationCustom04",
            required: ""
          }, _hoisted_23, 512), [
            [_vModelSelect, status.value]
          ]),
          _hoisted_24
        ]),
        _createElementVNode("div", { class: "col-12" }, [
          _createElementVNode("button", {
            class: "btn btn-secondary me-2",
            type: "button",
            style: {"background-color":"#24292F"},
            onClick: handleClick
          }, "Cancelar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            type: "button",
            style: {"background-color":"#001982"},
            onClick: handleSubmit
          }, "Enviar")
        ])
      ])
    ])
  ], 64))
}
}

})